import React from 'react';

type Props = {
  children: any,
};

// A simple wrapper for an animated group child to be used
// when there are no animations specified
class AnimatedGroupChildEmpty extends React.Component {
  props: Props;

  render() {
    const { children } = this.props;
    return React.Children.only(children);
  }
}

export default AnimatedGroupChildEmpty;
